import React, { useState } from 'react';
import { workOrderService } from '../services/workOrderService';
import { FiChevronDown, FiCheck, FiX, FiTruck } from 'react-icons/fi';

const StatusActions = ({ workOrder, onStatusChange }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [note, setNote] = useState('');

  const currentStatus = workOrder.status;
  const nextStatuses = workOrderService.getNextStatuses(currentStatus);

  const handleStatusChange = async (newStatus) => {
    setLoading(true);
    setError(null);
    try {
      const result = await workOrderService.updateStatus(workOrder.id, newStatus, note);
      console.log('✅ Status berhasil diubah:', result);
      if (result) {
        setNote('');
        onStatusChange && onStatusChange(result);
        setShowDropdown(false);
      }
    } catch (error) {
      console.error('❌ Error:', error);
      setError(error.message || 'Gagal mengubah status');
    } finally {
      setLoading(false);
    }
  };

  const getStatusIcon = (status) => {
    switch(status) {
      case 'completed':
        return <FiCheck size={16} className="text-green-600" />;
      case 'cancelled':
        return <FiX size={16} className="text-red-600" />;
      case 'delivered':
        return <FiTruck size={16} className="text-purple-600" />;
      default:
        return null;
    }
  };

  if (nextStatuses.length === 0) {
    return null;
  }

  return (
    <div className="relative">
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        disabled={loading}
        className="flex items-center space-x-1 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-lg transition-colors disabled:opacity-50"
      >
        <span>{loading ? 'Loading...' : 'Update Status'}</span>
        <FiChevronDown size={16} />
      </button>

      {showDropdown && (
        <div className="absolute right-0 mt-2 w-72 bg-[var(--bg-primary)] rounded-lg shadow-lg border border-[var(--border-color)] z-50">
          <div className="p-3">
            {error && (
              <div className="mb-2 text-xs text-red-600 bg-red-50 px-3 py-1.5 rounded-lg border border-red-200">
                {error}
              </div>
            )}

            <p className="text-xs text-[var(--text-secondary)] mb-2">Ubah status ke:</p>
            
            {nextStatuses.map((status) => (
              <button
                key={status}
                onClick={() => handleStatusChange(status)}
                disabled={loading}
                className="w-full text-left px-3 py-2 text-sm text-[var(--text-primary)] hover:bg-[var(--bg-secondary)] rounded-lg transition-colors flex items-center justify-between disabled:opacity-50"
              >
                <span>{workOrderService.getStatusLabel(status)}</span>
                {getStatusIcon(status)}
              </button>
            ))}
            
            {/* INPUT CATATAN */}
            <div className="mt-3 pt-3 border-t border-[var(--border-color)]">
              <label className="block text-xs text-[var(--text-secondary)] mb-1">
                Catatan Progress (opsional)
              </label>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Tambahkan catatan perubahan status..."
                className="w-full px-3 py-2 text-sm border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-1 focus:ring-blue-500 resize-none"
                rows={2}
                disabled={loading}
              />
              <p className="text-[10px] text-[var(--text-secondary)] mt-1">
                {note.length > 0 ? `${note.length} karakter` : 'Catatan akan muncul di timeline'}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatusActions;